__turbopack_context__.v({
  "bannerIcon": "HeroFooter-module__Vz-U6a__bannerIcon",
  "heroFooterBanner": "HeroFooter-module__Vz-U6a__heroFooterBanner",
  "heroFooterContainer": "HeroFooter-module__Vz-U6a__heroFooterContainer",
});
